import { combineReducers } from 'redux';
import common from './CommonReducer';
import company from './CompanyReducer';
import target from './TargetReducer';
import upload from './UploadReducer';
import matching from './MatchingReducer';
import logoutput from './LogOutputReducer';
import usermanaged from './UserManagedReducer';
import externaldata from './ExternalDataReducer';

export default combineReducers({
  common,
  company,
  target,
  upload,
  matching,
  logoutput,
  usermanaged,
  externaldata,
});
